import React, { useState, useCallback } from "react"
import PropTypes from "prop-types"
import { QuestionRenderer } from "./question-renderer"
import { questionShape } from "./types"
import { FormContainer } from "../form-fields/form-render/form-container"
import { cn } from "../../lib/utils"

// Simple questionnaire component that renders a single section/group of questions
const Questionnaire = ({ 
  title,
  questions = [], 
  onAnswersChange,
  initialAnswers = {},
  readOnly = false,
  className,
  children,
  demographicErrorMessages
}) => {
  const [answers, setAnswers] = useState(initialAnswers)
  
  const handleAnswerChange = useCallback((updatedAnswer) => {
    const newAnswers = {
      ...answers,
      [updatedAnswer.questionId]: updatedAnswer
    }
    setAnswers(newAnswers)
    onAnswersChange?.(updatedAnswer)
  }, [answers, onAnswersChange])

  const sortedQuestions = questions.sort((a, b) => (a.order || 0) - (b.order || 0))

  return (
    <FormContainer
      sectionTitle={title}
      className={className}
    >
      {children ? (
        children
      ) : (
        <div className="-mx-2 flex flex-wrap">
          <div className="w-full">
            <div className="space-y-4">
              {sortedQuestions.map(question => (
                <QuestionRenderer
                  key={question.questionId}
                  question={question}
                  answers={answers}
                  onAnswerChange={handleAnswerChange}
                  readOnly={readOnly}
                  demographicErrorMessages={demographicErrorMessages}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </FormContainer>
  )
}

Questionnaire.propTypes = {
  title: PropTypes.string,
  questions: PropTypes.arrayOf(questionShape),
  onAnswersChange: PropTypes.func,
  initialAnswers: PropTypes.object,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
}

Questionnaire.defaultProps = {
  title: null,
  questions: [],
  initialAnswers: {},
  onAnswersChange: null,
  readOnly: false,
  className: "",
  children: null
}

export { Questionnaire }